const pointToastMsg = {
  /**
   *  [포인트 내역 리스트] 포인트 내역 리스트 요청하기
   */
  GET_POINT_LIST_REQUEST_SUCCESS: '포인트 내역 리스트 요청하기 성공',
  GET_POINT_LIST_REQUEST_ERROR: '포인트 내역 리스트 요청하기 실패',

  /**
   *  [포인트 log] 포인트 log 요청하기
   */
  GET_POINT_LOG_REQUEST_SUCCESS: '포인트 LOG 요청하기 성공',
  GET_POINT_LOG_REQUEST_ERROR: '포인트 LOG 요청하기 실패',

  /**
   *  [포인트 랭킹] 포인트 랭킹 요청하기
   */
  GET_POINT_RANKING_REQUEST_SUCCESS: '포인트 랭킹 요청하기 성공',
  GET_POINT_RANKING_REQUEST_ERROR: '포인트 랭킹 요청하기 실패',

  /**
   *  [포인트 랭킹] 포인트 랭킹 리스트 엑셀 다운로드 요청하기
   */
  GET_POINT_RANKING_LIST_EXCEL_DOWNLOAD_REQUEST_SUCCESS: '포인트 랭킹 리스트 엑셀 다운로드 요청하기 성공',
  GET_POINT_RANKING_LIST_EXCEL_DOWNLOAD_REQUEST_ERROR: '포인트 랭킹 리스트 엑셀 다운로드 실패',

  /**
   *  [포인트 발급] 포인트 발급받을 유저 리스트 요청하기
   */
  GET_GENERATE_POINT_USER_LIST_REQUEST_SUCCESS: '포인트 발급받을 유저 리스트 요청하기 성공',
  GET_GENERATE_POINT_USER_LIST_REQUEST_ERROR: '포인트 발급받을 유저 리스트 요청하기 실패',

  /**
   * [포인트 발급] 포인트 발급 전 준비 데이터 받아오기
   */
  GET_PREPARATION_GENERATE_POINT_REQUEST_SUCCESS: '포인트 발급받을 유저 리스트 요청하기 성공',
  GET_PREPARATION_GENERATE_POINT_REQUEST_ERROR: '포인트 발급받을 유저 리스트 요청하기 실패',

  /**
   * [포인트 일괄 발급] 엑셀 일괄 발급 유효성 체크 요청하기
   */
  EXCEL_BULK_GENERATE_POINT_CHECK_REQUEST_SUCCESS: '포인트 엑셀 일괄 발급 유효성 체크 성공',
  EXCEL_BULK_GENERATE_POINT_CHECK_REQUEST_ERROR: '포인트 엑셀 일괄 발급 유효성 체크 실패',

  /**
   *  [포인트 발급] 포인트 발급받을 유저 리스트 엑셀 다운로드 요청하기
   */
  GENERATE_POINT_USER_LIST_EXCEL_DOWNLOAD_REQUEST_SUCCESS: '포인트 발급받을 유저 리스트 엑셀 다운로드 요청하기 성공',
  GENERATE_POINT_USER_LIST_EXCEL_DOWNLOAD_REQUEST_ERROR: '포인트 발급받을 유저 리스트 엑셀 다운로드 요청하기 실패',

  /**
   *  [포인트 발급 내역 리스트] 포인트 발급 내역 리스트 요청하기
   */
  GET_POINT_ISSUE_HISTORY_LIST_REQUEST_SUCCESS: '포인트 발급 내역 리스트 요청하기 성공',
  GET_POINT_ISSUE_HISTORY_LIST_REQUEST_ERROR: '포인트 발급 내역 리스트 요청하기 실패',

  /**
   *  [포인트 발급 내역 상세] 포인트 발급 내역 상세 요청하기
   */
  GET_POINT_ISSUE_HISTORY_DETAIL_REQUEST_SUCCESS: '포인트 발급 내역 상세 요청하기 성공',
  GET_POINT_ISSUE_HISTORY_DETAIL_REQUEST_ERROR: '포인트 발급 내역 상세 요청하기 실패',

  /**
   *  [포인트 발급 내역 상세] 포인트 발급 리스트 요청하기
   */
  GET_POINT_ISSUE_HISTORY_POINT_LOG_LIST_REQUEST_SUCCESS: '포인트 발급 내역에 연결 할 포인트 로그 리스트 요청하기 성공',
  GET_POINT_ISSUE_HISTORY_POINT_LOG_LIST_REQUEST_ERROR: '포인트 발급 내역에 연결 할 포인트 로그 리스트 요청하기 실패',

  /**
   *  [레퍼럴 발급 현황] 레퍼럴 발급 리스트 가져오기
   */
  GET_POINT_REFERRAL_ISSUE_LIST_REQUEST_SUCCESS: '레퍼럴 발급 리스트 요청하기 성공',
  GET_POINT_REFERRAL_ISSUE_LIST_REQUEST_ERROR: '레퍼럴 발급 리스트 요청하기 실패',

  /**
   *  [포인트 사유 리스트] 포인트 사유 리스트 가져오기
   */
  GET_POINT_CAUSE_LIST_REQUEST_SUCCESS: '포인트 사유 리스트 요청하기 성공',
  GET_POINT_CAUSE_LIST_REQUEST_ERROR: '포인트 사유 리스트 요청하기 실패',

  /**
   *  [포인트 사유 등록] 포인트 사유 등록하기
   */
  CREATE_POINT_CAUSE_REQUEST_SUCCESS: '포인트 사유 등록하기 성공',
  CREATE_POINT_CAUSE_REQUEST_ERROR: '포인트 사유 등록하기 성공',
};

export default pointToastMsg;
